"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireWildcard(require("react"));

var _utils = require("@alycecom/utils");

var _material = require("@mui/material");

var _useGetTeamMembersByTeamId = require("../../hooks/useGetTeamMembersByTeamId");

var SelectTeamMember = function SelectTeamMember(_ref) {
  var teamId = _ref.teamId,
      value = _ref.value,
      onChange = _ref.onChange,
      label = _ref.label,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? '' : _ref$name,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$helperText = _ref.helperText,
      helperText = _ref$helperText === void 0 ? '' : _ref$helperText,
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? false : _ref$error,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
      renderOptionLabel = _ref.renderOptionLabel,
      _ref$nullable = _ref.nullable,
      nullable = _ref$nullable === void 0 ? false : _ref$nullable,
      sortOptions = _ref.sortOptions,
      filterOptions = _ref.filterOptions;

  var _useGetTeamMembersByT = (0, _useGetTeamMembersByTeamId.useGetTeamMembersByTeamId)(teamId),
      isFulfilled = _useGetTeamMembersByT.isFulfilled,
      useGetAll = _useGetTeamMembersByT.useGetAll;

  var teamMembers = useGetAll();
  var emptyMembers = nullable ? [{
    id: 0,
    firstName: 'Sender',
    lastName: '',
    email: 'sender@alyce.com',
    imageUrl: ''
  }] : [];
  var processedTeamMembers = (0, _react.useMemo)(function () {
    var filteredTeamMembers = filterOptions ? teamMembers.filter(filterOptions) : teamMembers;
    return sortOptions ? filteredTeamMembers.sort(sortOptions) : teamMembers;
  }, [sortOptions, filterOptions, teamMembers]);
  var members = [].concat(emptyMembers, (0, _toConsumableArray2.default)(processedTeamMembers));
  var labelId = (0, _react.useMemo)(function () {
    return "SelectTeamMember_".concat((0, _utils.toUnderscore)(label), "_label");
  }, [label]);
  return /*#__PURE__*/_react.default.createElement(_material.FormControl, {
    variant: "outlined",
    error: error,
    disabled: disabled || !isFulfilled,
    fullWidth: fullWidth
  }, /*#__PURE__*/_react.default.createElement(_material.InputLabel, {
    id: labelId
  }, label), /*#__PURE__*/_react.default.createElement(_material.Select, {
    labelId: labelId,
    label: label,
    value: value,
    onChange: onChange,
    name: name
  }, members.map(function (member) {
    return /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
      key: member.id,
      value: member.id
    }, renderOptionLabel ? renderOptionLabel(member) : "".concat(member.firstName, " ").concat(member.lastName));
  })), helperText && /*#__PURE__*/_react.default.createElement(_material.FormHelperText, null, helperText));
};

var _default = SelectTeamMember;
exports.default = _default;